const API_BASE_URL = process.env.REACT_APP_INFINITYS_API ;

const API_ENDPOINTS = {
  CALLS: {
    TOKEN: `${API_BASE_URL}/api/calls/token`,
    // Only token endpoint needed - call start/end handled by frontend
  },
};

const AZURE_CONFIG = {
  CALLER_ID: process.env.REACT_APP_AZURE_CALLER_ID,
  AGENT_DISPLAY_NAME: process.env.REACT_APP_AGENT_DISPLAY_NAME || 'Lead Portal User',
};

export { API_ENDPOINTS, AZURE_CONFIG };
